import { Component, inject } from '@angular/core';
import { ClientDiaryService } from '@app/services/clientdiary.service';
import { DASHBOARD_PATHS } from '@modules/dashboard/dashboard.paths';
import { NavItem } from '@schema/nav.models';
import { PermissionService } from '@shared/services/permission.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'lgv-dashboard-wrapper',
  template: '<lgv-navigation  [navItems]="navItems"> </lgv-navigation>',
  styles: [
    `
      :host {
        flex-grow: 1;
        display: flex;
      }
    `,
  ],
  standalone: false,
})
export class DashboardWrapperComponent {
  private permissionService = inject(PermissionService);
  clientDiaryService = inject(ClientDiaryService);

  constructor() {
    this.clientDiaryService.getClientDiaryUnread();
  }

  navItems: NavItem[] = [
    {
      text: 'dashboard_nav_client',
      iconText: 'local_hospital',
      route: DASHBOARD_PATHS.DASHBOARD_CLIENT,
      visible: new BehaviorSubject(true),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_employee',
      iconText: 'face',
      route: DASHBOARD_PATHS.DASHBOARD_EMPLOYEE,
      visible: new BehaviorSubject(true),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_diary',
      iconText: 'book',
      route: DASHBOARD_PATHS.DASHBOARD_DIARY,
      visible: new BehaviorSubject(true),
      routerActive: true,
      badgeCount: this.clientDiaryService.diaryUnread,
    },
    {
      text: 'dashboard_nav_schedulingpro',
      iconText: 'calendar_today',
      route: DASHBOARD_PATHS.DASHBOARD_SCHEDULING_PRO,
      visible: this.permissionService.hasPermissionObservable('calendar_pro'),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_schedulingabsence',
      iconText: 'beach_access',
      route: DASHBOARD_PATHS.DASHBOARD_SCHEDULING_ABSENCE,
      visible: this.permissionService.hasPermissionObservable('calendar_pro'),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_sicknotes',
      iconText: 'sick',
      route: DASHBOARD_PATHS.DASHBOARD_SICKNOTES,
      visible: new BehaviorSubject(true),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_reporting',
      iconText: 'insights',
      route: DASHBOARD_PATHS.DASHBOARD_REPORTING2,
      visible: this.permissionService.hasPermissionObservable('reporting_new'),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_forms',
      iconText: 'view_stream',
      route: DASHBOARD_PATHS.DASHBOARD_FORMS,
      visible: this.permissionService.includeDomainObservable('@longevo.at'),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
    {
      text: 'dashboard_nav_users',
      iconText: 'people',
      route: DASHBOARD_PATHS.DASHBOARD_USERS,
      visible: new BehaviorSubject(true),
      routerActive: true,
      badgeCount: new BehaviorSubject(0),
    },
  ];
}
